export default __webpack_public_path__ + "f102736268b1de55ce81ea6e5219e15d.jpg";